import React from 'react';
import { FiChevronLeft, FiChevronRight } from 'react-icons/fi';
import './ListPager.css';

/**
 * Simple prev/next pager for server-paginated lists.
 */
export default function ListPager({
  page = 1,
  pageCount = 1,
  total,
  limit,
  onPageChange,
  className = '',
  disabled = false,
}) {
  const safePage = Math.max(1, Number(page) || 1);
  const safeCount = Math.max(1, Number(pageCount) || 1);
  const canPrev = !disabled && safePage > 1;
  const canNext = !disabled && safePage < safeCount;
  if (safeCount <= 1 && (total == null || total <= (limit || 0))) {
    return null;
  }

  return (
    <div className={`list-pager ${className}`.trim()} role="navigation" aria-label="Pagination">
      <button
        type="button"
        className="btn btn-secondary btn-sm list-pager__btn"
        disabled={!canPrev}
        aria-label="Previous page"
        onClick={() => onPageChange?.(safePage - 1)}
      >
        <FiChevronLeft aria-hidden />
        Prev
      </button>
      <span className="list-pager__meta">
        Page {safePage} of {safeCount}
        {total != null ? ` · ${total} total` : ''}
      </span>
      <button
        type="button"
        className="btn btn-secondary btn-sm list-pager__btn"
        disabled={!canNext}
        aria-label="Next page"
        onClick={() => onPageChange?.(safePage + 1)}
      >
        Next
        <FiChevronRight aria-hidden />
      </button>
    </div>
  );
}
